import React from "react";
import { Routes, Route } from "react-router-dom";
import AttendancePage from "../screens/AttendancePage";
import EmployeeAttendance from "../screens/EmployeeAttendance";
import AttendanceRegister from "../screens/AttendanceRegister";
import StudentAttendanceRegister from "../screens/StudentAttendanceRegister";
import { AttendanceCacheProvider } from "../context/AttendanceContext";
import { 
  KVAttendanceList, 
  KVAttendanceDetail, 
  EmployeeAttendanceDetail,
  AnalyticsComparisonDashboard,
  ROAttendanceList
} from "../screens/analytics";
import {
  StudentKVAttendanceList,
  StudentKVAttendanceDetail,
  StudentAnalyticsComparisonDashboard
} from "../screens/student-analytics";
import StudentClassDetail from "../screens/student-analytics/StudentClassDetail";
import StudentSectionDetail from "../screens/student-analytics/StudentSectionDetail";
import StudentDetail from "../screens/student-analytics/StudentDetail";
import RegionAttendanceList from "../screens/RegionAttendanceList";
import TodaysAttendanceOverview from "../screens/TodaysAttendanceOverview";
import StaffMonthlyAttendance from "../screens/StaffMonthlyAttendance";
import StaffDailyAttendance from "../screens/StaffDailyAttendance";

const AttendanceRoutes: React.FC = () => (
  <AttendanceCacheProvider>
    <Routes>
      <Route path="/" element={<AttendancePage />} />
      <Route path="/employee" element={<EmployeeAttendance />} />
      <Route path="/employee/:empId" element={<AttendanceRegister />} />
      <Route path="/employee/register" element={<AttendanceRegister />} />
      <Route path="/student/register" element={<StudentAttendanceRegister />} />
      
      {/* Staff Monthly Attendance Register */}
      <Route path="/monthly" element={<StaffMonthlyAttendance />} />

      {/* Staff Daily Attendance Register */}
      <Route path="/daily" element={<StaffDailyAttendance />} />

      {/* Employee Analytics Routes - Comparison Dashboard */}
      <Route path="/analytics/compare" element={<AnalyticsComparisonDashboard />} />
      
      {/* Employee Analytics Routes - RO-wise attendance visualization */}
      <Route path="/analytics" element={<ROAttendanceList />} />
      <Route path="/analytics/kv-list" element={<KVAttendanceList />} />
      <Route path="/analytics/kv/:kvId" element={<KVAttendanceDetail />} />
      <Route path="/analytics/kv/:kvId/employee/:empId" element={<EmployeeAttendanceDetail />} />

      {/* Student Analytics Routes - Comparison Dashboard */}
      <Route path="/student/analytics/compare" element={<StudentAnalyticsComparisonDashboard />} />
      
      {/* Region-wise Student Attendance Route */}
      <Route path="/regions" element={<RegionAttendanceList />} />

      {/* Today's Attendance Overview (summary + region-wise) */}
      <Route path="/student/todays-overview" element={<TodaysAttendanceOverview />} />
      
      {/* Region's KV Schools List Route */}
      <Route path="/region/:roId/schools" element={<StudentKVAttendanceList />} />
      
      {/* Student Analytics Routes - KV-wise student attendance visualization */}
      <Route path="/student/analytics" element={<StudentKVAttendanceList />} />
      <Route path="/student/analytics/kv/:kvId" element={<StudentKVAttendanceDetail />} />
      
      {/* Student Analytics Routes - Class and Section detail */}
      <Route path="/student/analytics/class/:classId" element={<StudentClassDetail />} />
      <Route path="/student/analytics/kv/:kvId/class/:classNum/section/:section" element={<StudentSectionDetail />} />
      
      {/* Student Detail Route */}
      <Route path="/student/analytics/student/:studentId" element={<StudentDetail />} />
    </Routes>
  </AttendanceCacheProvider>
);

export default AttendanceRoutes;
